import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'
import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'
import { compose } from 'redux'

import { Nullable } from 'clickNgo/models/utils'
import { resetAllModifiedDataByKey } from 'cng-common/features/form'
import { CrudStore } from 'core/types/crudStore'
import { selectIsSelectedDocumentChanged } from 'partner360/features/QBR'
import { fetchQbrMainData } from 'partner360/services/qbr/fetchQbrMainData'

import { QBR_SETTINGS_FORM_KEY } from '../../../components/QBR/components/qbrDocumentDetails/components/steps/settingsStep/components/qbrSettingsForm'
import { REQUEST_FINALIZE_DOCUMENT_WITHOUT_SAVING_CHANGES } from '../constants'

import { IRequestResetDataResult } from './requestResetData'

export const requestFinalizeDocumentWithoutSavingChanges = createAsyncThunk<
  Nullable<IRequestResetDataResult>,
  number
>(REQUEST_FINALIZE_DOCUMENT_WITHOUT_SAVING_CHANGES, async (documentId, { dispatch, getState }) => {
  try {
    dispatch(resetAllModifiedDataByKey(QBR_SETTINGS_FORM_KEY))

    const hasSignificantChanges = compose(selectIsSelectedDocumentChanged, getState)()

    const crud = CrudStore.get(CrudStoreItemPartner360.JBPQBRDocument, 'finalizeDocument')
    await crud.update(1554, [{ EntryId: documentId, Finalized: 1 }])

    if (hasSignificantChanges) {
      const initialData = await fetchQbrMainData({ documentId })

      if (initialData) {
        return {
          partners: initialData?.partners,
          qbrDocument: { ...initialData.qbrDocument, Finalized: 1 },
        }
      }
    }
    return null
  } catch (e) {
    throw new Error()
  }
})
